import { FieldErrors, useFormContext } from 'react-hook-form'
import { BefehlFormField } from '../Generic'
import AuftragCheckbox from '../Generic/AuftragCheckbox'
import { useTranslation } from 'react-i18next'
import { Befehl21FormData } from './schema/befehl21-form.schema'
import { useEffect, useMemo } from 'react'

export interface Auftrag21_12_13FormProps {
  readOnly: boolean
  'data-testid': string
  activateEmptyFieldWarnings: boolean
  errors?: FieldErrors
}

export default function Auftrag21_12_13Form({
  readOnly,
  'data-testid': testId,
  activateEmptyFieldWarnings,
  errors
}: Readonly<Auftrag21_12_13FormProps>) {
  const { t } = useTranslation('ui-befehle')

  const { control, formState, watch, setValue } =
    useFormContext<Befehl21FormData>()

  const fieldErrors = useMemo(() => {
    return errors ?? formState.errors
  }, [errors, formState.errors])

  const auftrag21_12_enabled = watch('auftrag21_12.enabled')
  const auftrag21_13_enabled = watch('auftrag21_13.enabled')

  useEffect(() => {
    if (auftrag21_12_enabled) {
      setValue('auftrag21_13.enabled', false)
    }
  }, [auftrag21_12_enabled, setValue])

  useEffect(() => {
    if (auftrag21_13_enabled) {
      setValue('auftrag21_12.enabled', false)
    }
  }, [auftrag21_13_enabled, setValue])

  return (
    <div className="flex flex-wrap sm:flex-nowrap pl-4 gap-2 items-baseline ml-0.25">
      {(!readOnly || auftrag21_12_enabled) && (
        <BefehlFormField
          name="auftrag21_12.enabled"
          control={control}
          label=""
          readOnly={readOnly}
          activateEmptyWarning={activateEmptyFieldWarnings}
          data-testid={`${testId}-auftrag-21-12`}
          render={({ field }) => (
            <div className="flex items-baseline gap-0.5">
              <div className="flex justify-center items-start pt-0.25">
                <AuftragCheckbox
                  checked={field.value}
                  label={`21.12`}
                  onChange={(e) => field.onChange(e.target.checked)}
                  readOnly={readOnly}
                  data-testid={`${testId}-auftrag-21-12-inner`}
                  errors={fieldErrors}
                />
              </div>
              <span data-testid={`${testId}-text-einfahren`}>
                {t('auftraege.21_12_13.einfahren')}
              </span>
            </div>
          )}
        />
      )}

      {!readOnly && (
        <span data-testid={`${testId}-text-oder`}>
          {t('auftraege.21_12_13.oder')}
        </span>
      )}

      {(!readOnly || auftrag21_13_enabled) && (
        <BefehlFormField
          name="auftrag21_13.enabled"
          control={control}
          label=""
          readOnly={readOnly}
          activateEmptyWarning={activateEmptyFieldWarnings}
          data-testid={`${testId}-auftrag-21-13`}
          render={({ field }) => (
            <div className="flex items-baseline gap-0.5">
              <div className="flex justify-center items-start pt-0.25">
                <AuftragCheckbox
                  checked={field.value}
                  label={`21.13`}
                  onChange={(e) => field.onChange(e.target.checked)}
                  readOnly={readOnly}
                  data-testid={`${testId}-auftrag-21-13-inner`}
                  errors={fieldErrors}
                />
              </div>
              <span data-testid={`${testId}-text-weiterfahren`}>
                {t('auftraege.21_12_13.weiterfahren')}
              </span>
            </div>
          )}
        />
      )}
    </div>
  )
}
